import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import ContentAdd from 'material-ui/svg-icons/content/add';
import IconButton from 'material-ui/IconButton';
import muiTheme from '../../../styles/teamologyTheme';
import {withRouter} from 'react-router';
import React, {Component, PropTypes} from 'react';

class AddPostButtonMobile extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  handleAddContentTouch() {
    const {router} = this.props;
    router.push('/add-post');
  }

  render() {
    return (
      <div className="add-post-button-container">
        <IconButton iconStyle={muiTheme.addPostButton} onTouchTap={this.handleAddContentTouch}><ContentAdd /></IconButton>
      </div>
    );
  }
}

AddPostButtonMobile.propTypes = {
  router: PropTypes.object.isRequired,
};

export default withRouter(connect(null)(AddPostButtonMobile));



// WEBPACK FOOTER //
// ./app/features/newCommunityPost/components/AddPostButtonMobile.js